// Array of white listed URLs for the AML admin desk that should not trigger a session refresh.
const whitelistUrlPatterns: string[] = [
  '/storage.googleapis.com/',
  '/i18n/',
  'authentication/sign-in',
  '/public/',
  '/assets/',
];

/**
 * Checks if the given URL is part of the whitelisted endpoint patterns.
 *
 * @param {string} url - The URL to check against the whitelist patterns.
 * @returns {boolean} True if the URL matches any of the whitelisted patterns, false otherwise.
 */
export function isWhitelistedEndpoint(url: string): boolean {
  return whitelistUrlPatterns.some((pattern) => url.includes(pattern));
}
